;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	
	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');
	
	Collection.TippingLadder =  Backbone.Collection.extend({
		url: function() {
			return this.methodUrl;
		},
		isNew: function(){
			return true;
		},
		getOfficialLadder: function() {
			this.setApiUrl('ladder.json');
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));